import BASE_URL from "components/BaseUrl/apiConfig";
import Footer from "components/Footers/Footer";
import Navbar from "components/Navbars/AuthNavbar";
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import pdfimg from "assets/img/pdf.png";
import pptimg from "assets/img/ppt.png";
import excelimg from "assets/img/xls.png";
import notpadimg from "assets/img/notepad.png";

const ViewDocuments = (props) => {
  const history = useHistory();
  const [documentDetails, setDocumentDetails] = useState(null);

  // Extract documentId from location state
  const documentId = props.location.state.documentId;

  useEffect(() => {
    // Fetch document details based on documentId
    const fetchDocumentDetails = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/api/Document/GetDocumentsbyId?documentId=${documentId}`
        );
        const data = await response.json();
        setDocumentDetails(data);
      } catch (error) {
        console.error("Error fetching document details:", error);
      }
    };

    fetchDocumentDetails();
  }, [documentId]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    // Pad single digits with leading zero
    const formattedDay = String(day).padStart(2, "0");
    const formattedMonth = String(month).padStart(2, "0");

    return `${formattedDay}/${formattedMonth}/${year}`;
  };

  // Function to check if the file path corresponds to an image
  const isImage = (filePath) => {
    const imageExtensions = [".jpg", ".jpeg", ".png", ".gif", ".bmp"]; // Add more image extensions if needed
    const extension = filePath.substring(filePath.lastIndexOf(".")); // Get the file extension

    return imageExtensions.includes(extension.toLowerCase());
  };

  const getDocumentName = (filePath) => {
    // Find the index of the underscore (_) character after 'wwwroot/Documents\'
    const underscoreIndex = filePath.indexOf(
      "_",
      filePath.indexOf("wwwroot/Documents\\")
    );

    // Extract the document name from the file path
    const fileName = filePath.substring(underscoreIndex + 1);

    return fileName;
  };

  const getDocumentImageSrc = (filePath) => {
    const extension = filePath
      .substring(filePath.lastIndexOf("."))
      .toLowerCase();
    switch (extension) {
      case ".pdf":
        return pdfimg; // Assuming pdfimg is the image source for PDF files
      case ".doc":
      case ".docx":
        return document; // Assuming wordimg is the image source for Word files
      case ".xls":
      case ".xlsx":
        return excelimg; // Assuming excelimg is the image source for Excel files
      case ".ppt":
      case ".pptx":
        return pptimg; // Assuming pptimg is the image source for PowerPoint files
      case ".txt":
        return notpadimg; //Assuming notpadimg is the image source for Notpad files
      default:
        return document; // Default image source for other document types
    }
  };

  //const imageUrl = "https://localhost:7208";
  const document = "https://cdn-icons-png.flaticon.com/128/2991/2991108.png";

  return (
    <>
      <Navbar />
      <div className="cust-div" style={{ minHeight: "550px" }}>
        <div className="container mx-auto mt-8 p-4">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-2xl font-bold">Document Details</h1>
            <div>
              <button
                className="bg-lightBlue-500 text-white active:bg-lightBlue-600 mr-3 text-xs font-bold uppercase px-4 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
                type="button"
                onClick={() => history.goBack()}
              >
                <i
                  className="fa fa-arrow-circle-left mr-1"
                  title="Go To Documents Library"
                ></i>
              </button>
            </div>
          </div>
          {documentDetails && (
            <div>
              <div>
                <strong>Uploaded Date:</strong>{" "}
                {formatDate(documentDetails.createdOn)}
              </div>
              <div>
                <strong>Description:</strong> {documentDetails.description}
              </div>
              <div>
                <strong>Documents:</strong>
                {documentDetails.filePath && (
                  <div className="flex">
                    {documentDetails.filePath
                      .split(",")
                      .map((filePath, index) => (
                        <div
                          key={index}
                          style={{
                            marginTop: "10px",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          {/* First data */}
                          <div
                            style={{ marginRight: "10px", display: "table" }}
                          >
                            {isImage(filePath) ? (
                              // <a
                              //     href={BASE_URL + filePath.replace('wwwroot', '')}
                              //     download={`document_${index}.jpg`} // Set the filename for downloaded file
                              //     target="_blank" // Open in a new tab
                              //     style={{ display: 'table' }}
                              // >
                              //     <img
                              //         src={BASE_URL + filePath.replace('wwwroot', '')}
                              //         alt={`Image ${index}`}
                              //         style={{ width: '100%', maxWidth: '175px', borderRadius: '5px', boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)' }}
                              //     />
                              // </a>
                              <div style={{ textAlign: "center" }}>
                                <a
                                  href={
                                    BASE_URL + filePath.replace("wwwroot", "")
                                  }
                                  download={`document_${index}.jpg`} // Set the filename for downloaded file
                                  target="_blank" // Open in a new tab
                                  style={{ display: "table" }}
                                  title={getDocumentName(filePath)}
                                >
                                  <img
                                    src={
                                      BASE_URL + filePath.replace("wwwroot", "")
                                    }
                                    alt={`Image ${index}`}
                                    style={{
                                      width: "100px",
                                      height: "100px",
                                      borderRadius: "5px",
                                      boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
                                    }}
                                  />
                                </a>
                                {/* <span>{getDocumentName(filePath)}</span> */}
                                <span
                                  style={{
                                    textAlign: "center",
                                    marginTop: "5px",
                                    marginBottom: "0",
                                  }}
                                  title={getDocumentName(filePath)}
                                >
                                  {getDocumentName(filePath).length > 19
                                    ? `${getDocumentName(filePath).substring(
                                        0,
                                        10
                                      )}...`
                                    : getDocumentName(filePath)}
                                </span>
                                <br />
                              </div>
                            ) : (
                              <div style={{ textAlign: "center" }}>
                                <a
                                  href={
                                    BASE_URL + filePath.replace("wwwroot", "")
                                  }
                                  target="_blank" // Open in a new tab
                                  rel="noopener noreferrer" // Security measure for target="_blank"
                                  style={{ display: "table" }}
                                >
                                  <img
                                    src={getDocumentImageSrc(filePath)}
                                    title={getDocumentName(filePath)}
                                    alt={`Document ${index}`}
                                    style={{ maxWidth: "100px" }}
                                  />
                                </a>

                                <span
                                  style={{
                                    textAlign: "center",
                                    marginTop: "5px",
                                    marginBottom: "0",
                                  }}
                                  title={getDocumentName(filePath)}
                                >
                                  {getDocumentName(filePath).length > 19
                                    ? `${getDocumentName(filePath).substring(
                                        0,
                                        10
                                      )}...`
                                    : getDocumentName(filePath)}
                                </span>
                                <br />
                              </div>
                            )}
                          </div>

                          {/* Second data */}
                          {index + 1 <
                            documentDetails.filePath.split(",").length && (
                            <div style={{ display: "table" }}>
                              {/* Render your second data here */}
                            </div>
                          )}
                        </div>
                      ))}
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ViewDocuments;
